import AXIOS from '@/axios-instance';

export default {

  retrieveSurveyAnswersForProcess(uuid){
    return AXIOS.get("/px/evaluation/process/"+uuid+"/timestamp");
  },
  retrieveSurveyAnswersWithoutProcess(moduleId){
    return AXIOS.get("/px/evaluation/module/"+moduleId);
  },
  retrieveEvaluationForSingleSurvey(surveyId){
    return AXIOS.get("/px/evaluation/"+surveyId)
  },
  retrieveTimestampEvaluationsForSurvey(surveyId, module){
    return AXIOS.get("/px/evaluation/timestamp/"+surveyId+"/module/"+module);
  },
  retrieveAnswersForCustomSurvey(surveyId){
    return AXIOS.get("/px/survey/"+surveyId+"/answers")
  }
}